const defaults = {
  ALLOW_WALL_ISLANDS: true,
  MIN_DISTANCE: 32,
  NUMBER_OF_POINTS: 50,
  SHOULD_DRAW_EXTRA_INFO: false,
  SHOULD_SMOOTH: true,
  WALL_PERCENT: 40
}

export let ALLOW_WALL_ISLANDS: boolean = defaults.ALLOW_WALL_ISLANDS
export let MIN_DISTANCE: number = defaults.MIN_DISTANCE
export let NUMBER_OF_POINTS: number = defaults.NUMBER_OF_POINTS
export let SHOULD_DRAW_EXTRA_INFO: boolean = defaults.SHOULD_DRAW_EXTRA_INFO
export let SHOULD_SMOOTH: boolean = defaults.SHOULD_SMOOTH
// WALL_PERCENT is approximate, not forced
export let WALL_PERCENT: number = defaults.WALL_PERCENT

export const setConstsFromForm = () => {
  // @ts-ignore
  const formMinDistance: HTMLInputElement = document.getElementById(
    "form-min-distance"
  )
  if (formMinDistance.value) {
    MIN_DISTANCE = Number(formMinDistance.value)
  } else {
    formMinDistance.value = defaults.MIN_DISTANCE.toString()
  }

  // @ts-ignore
  const formNumberOfPoints: HTMLInputElement = document.getElementById(
    "form-num-points"
  )
  if (formNumberOfPoints.value) {
    NUMBER_OF_POINTS = Number(formNumberOfPoints.value)
  } else {
    formNumberOfPoints.value = defaults.NUMBER_OF_POINTS.toString()
  }

  // @ts-ignore
  const formWallPercent: HTMLInputElement = document.getElementById(
    "form-wall-percent"
  )
  if (formWallPercent.value) {
    WALL_PERCENT = Number(formWallPercent.value)
  } else {
    formWallPercent.value = defaults.WALL_PERCENT.toString()
  }

  // @ts-ignore
  const formWallIslands: HTMLInputElement = document.getElementById(
    "form-wall-islands"
  )
  ALLOW_WALL_ISLANDS = formWallIslands.checked

  // @ts-ignore
  const formExtraInfo: HTMLInputElement = document.getElementById(
    "form-extra-info"
  )
  SHOULD_DRAW_EXTRA_INFO = formExtraInfo.checked

  // @ts-ignore
  const formShouldSmooth: HTMLInputElement = document.getElementById(
    "form-should-smooth"
  )
  SHOULD_SMOOTH = formShouldSmooth.checked
}
